const termLinks = Array.from(document.getElementsByClassName('toggle-product-terms'));

termLinks.forEach((link) => {
  const parentElement = link.parentNode;
  link.addEventListener('click', (event) => {
    event.preventDefault();

    termLinks.forEach((similarTermLinks) => {
      if (similarTermLinks !== link) {
        similarTermLinks.parentNode.classList.remove('open');
      }
    });

    parentElement.classList.toggle('open');
  });
});


const toggleDisplayProductFilter = document.getElementById('toggle-product-filters');
if (toggleDisplayProductFilter) {
  toggleDisplayProductFilter.addEventListener('click', (event) => {
    event.preventDefault();
    toggleDisplayProductFilter.parentNode.classList.toggle('closed');
  });
}
